import Movers from "./movers";

const ModuleName = "tfApp.market";

export default angular.module(ModuleName, [Movers(ModuleName)])
                      .name;
